<template>
    <div>
        <div class="nodata">
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
.nodata {
    height: 200px;
    width: 100%;
    margin: 20px auto 0;
}
</style>
